/**
 * 統合カードトークナイザー
 *
 * サイトの決済プロバイダーに応じて
 * 適切なトークンSDKを使用してカードトークンを生成
 */

import * as fincodeLoader from './fincodeLoader';
import * as gmoPgLoader from './gmoPgLoader';

export type PaymentProvider = 'fincode' | 'gmo_pg';

export interface CardData {
  cardNumber: string;
  expire: string; // YYMM 形式
  securityCode: string;
  holderName?: string;
}

export interface TokenizerOptions {
  /** GMO PG の場合に使用する Shop ID（API から取得） */
  gmoPgShopId?: string;
  /** 決済テストモード（true: テスト環境を使用） */
  testMode?: boolean;
}

/**
 * カードトークンを生成
 *
 * @param provider 決済プロバイダー
 * @param cardData カード情報
 * @param options オプション（GMO PG Shop ID、テストモードなど）
 * @returns トークン
 */
export const createCardToken = async (
  provider: PaymentProvider,
  cardData: CardData,
  options?: TokenizerOptions
): Promise<string> => {
  switch (provider) {
    case 'gmo_pg':
      return gmoPgLoader.createCardToken(cardData, options?.gmoPgShopId, options?.testMode ?? false);
    case 'fincode':
    default:
      return fincodeLoader.createCardToken(cardData, options?.testMode ?? true);
  }
};

// 共通のバリデーション関数をエクスポート
export const validateCardNumber = fincodeLoader.validateCardNumber;
export const formatCardNumber = fincodeLoader.formatCardNumber;
export const validateExpiry = fincodeLoader.validateExpiry;
export const formatExpiry = fincodeLoader.formatExpiry;
export const expiryToYYMM = fincodeLoader.expiryToYYMM;
export const validateSecurityCode = fincodeLoader.validateSecurityCode;
export const getCardBrand = fincodeLoader.getCardBrand;
